import Vue from 'vue'
import Vuex from 'vuex'
// import axios from "axios";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{},
    userFile:{},
    searchFile:{},
    selectedFolder:"",
    selectedFolderPath:""
  },
  getters:{
    getUserInfo(state){
      return state.userInfo;
    },
    getFolderId(state){
      return state.selectedFolder
    },
    getFolderPath(state){
      return state.selectedFolderPath
    },
    getUserFile(state){
      return state.userFile
    },
    getSearch(state){
      return state.searchFile
    }
  },
  mutations: {
    setUserInfo(state, payload){
      state.userInfo = payload;
    },
    setUserFile(state, payload){
      state.userFile = payload;
    },
    setSearch(state, payload){
      state.searchFile = payload;
    },
    setSelectedFolder(state,payload){
      state.selectedFolder = payload;
    },
    setSelectedFolderPath(state,payload){
      state.selectedFolderPath = payload;
    }
  },
  actions: {
    async userFile({commit},payload)  {
      return ApiCaller(constant.BASE_API_URL, "/file/user_file", "get",null,payload.headers).then(response=>{
        commit('setUserFile',response);
      });
    },
    async uploadFile({commit},payload)  {
      console.log("commit userfile",commit);
      console.log('options:up ',payload.headers);
      console.log('options:upload h ',payload.body);
      // console.log("payload user file: ",payload);
      console.log("==============================>>>>>>>>",payload.body)
      return ApiCaller(constant.FILE_UPLOAD_URL, "/upload_file/", "post",payload.body,payload.headers)
    
    },
    createFolder({type},{payload}) {
      console.log("commit",type);;
      return ApiCaller(constant.BASE_API_URL, "/file/create_folder", "post",payload);
    },
    renameFolder({type},{payload}) {
      console.log("commit",type);
      return ApiCaller(constant.BASE_API_URL, "/file/rename_folder", "post",payload);
    },
    downloadFile({type},{payload}) {
      console.log("commit",type);
      console.log("commit",payload);
      console.log("download","file/download"+`/${payload.file_id}`)
      return ApiCaller(constant.BASE_API_URL, "file/download"+`/${payload.file_id}`, "get");
    },
    moveFolder({type},{payload}) {
      console.log("commit",type);
      return ApiCaller(constant.BASE_API_URL, "/file/move_to_folder", "post",payload);
    },
    moveFile({type},{payload}) {
      console.log("commit",type);
      return ApiCaller(constant.BASE_API_URL, "/file/move_to_file", "post",payload);
    },
    deleteFolder({type},{payload}) {
      console.log("commit",type);
      return ApiCaller(constant.BASE_API_URL, "/file/delete_folder", "post",payload);
    },
    deleteFile({type},{payload}) {
      console.log("commit userfile",type);
      console.log("download","file/download"+`/${payload.file_id}`)
      return ApiCaller(constant.BASE_API_URL, "file/delete_file"+`/${payload.file_id}`, "delete")
    },
    async search({commit},{payload}) {
      
      return ApiCaller(constant.BASE_API_URL, "/auth/search", "post",payload).then(response=>{
        if(Array.isArray(response.data)) commit('setSearch',response);
        else commit('seSearch',{data:[]});


      });
    },
    async getUserProfile({ commit }) {
      return ApiCaller(constant.BASE_API_URL, "/auth/profile", "get").then(response=>{
        commit('setUserInfo',response.data);
      });
    },
  },
  modules: {
  }
})
